import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../api/Axios";
import { useAuth } from "../contexts/AuthContext";


const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post('accounts/login/', { email, password });
      const data = response.data;

      // Use the auth context login function instead of directly setting localStorage
      await login(data);
      
      // Wait a bit longer to ensure state is fully updated before navigation
      setTimeout(() => {
        // Redirect based on user_type
        switch (data.user_type) {
          case 'student':
            navigate('/student-dashboard', { replace: true });
            break;
          case 'accommodation_provider':
            navigate('/provider-dashboard', { replace: true });
            break;
          case 'primary_representative':
          case 'secondary_representative':
          case 'bmo_officer':
            navigate('/general-dashboard', { replace: true });
            break;
          case 'back_office':
            navigate('/backoffice-dashboard', { replace: true });
            break;
          case 'bmo_user_admin':
            navigate('/bmo-user-admin-dashboard', { replace: true });
            break;
          case 'inspector':
            navigate('/inspector-dashboard', { replace: true });
            break;
          case 'tutoring_agent':
            navigate('/tutor-provider-dashboard', { replace: true });
            break;
          case 'tutor':
            navigate('/tutor-dashboard', { replace: true });
            break;
          case 'funder_primary_representative':
          case 'funder_secondary_representative':
          case 'funder_officer':
            // TODO: Create funder dashboards
            navigate('/general-dashboard', { replace: true });
            break;
          default:
            navigate('/general-dashboard', { replace: true });
            break;
        }
      }, 250); // Increased delay to ensure state sync
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setError('Invalid credentials. Please check your email and password.');
      } else if (err.response && err.response.status === 403) {
        setError(err.response.data.detail || 'Your email is not verified. Please check your inbox.');
      } else {
        setError(
          err.response?.data?.detail ||
          err.message ||
          'An unexpected error occurred during login.'
        );
      }
    }
  };





    //push the html 

  return (
     <div style={{
        backgroundColor: 'rgba(255, 255, 255, 0.17)',
        color: 'rgba(255, 255, 255)',
        padding: '2rem',
        margin: '1rem 0',
        boxShadow: '-2px 1px 5px 0px rgba(0,0,0,0.10)',
        WebkitBoxShadow: '-2px 1px 5px 0px rgba(0,0,0,0.10)',
        MozBoxShadow: '-2px 1px 5px 0px rgba(0,0,0,0.10)'
    }}>

   
              
                              <form onSubmit={handleLogin}>

                               <div className="row">


                              

                                <div className="col-md-12">
                    <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                           className="form-control"
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    required
                        />
                    </div>
                </div>

                 </div>


                                  <div className="row">


                              

                                <div className="col-md-12">
                    <div className="mb-3">
                        <label className="form-label">Password</label>
                      <input
                                    className="form-control"
                                    type="password"
                                    placeholder="Enter your password"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    required
                                  />
                    </div>
                </div>

                 </div>


                              
                          
                                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                                <div className="form-btn">
                                  <button className="btn btn-primary btn-block" type="submit">
                                    Login
                                  </button>
                                </div>
                                <div className="text-center mt-3">
                                  <Link to="/forgot-password" style={{ color: "#fff", textDecoration: "underline" }}>
                                    Forgot your password?
                                  </Link>
                                </div>
                                <div className="text-center mt-2">
                                  <span style={{ color: "#fff" }}>Don't have an account? </span>
                                  <Link to="/StudentRegister" style={{ color: "#fff", textDecoration: "underline" }}>
                                    Register here
                                  </Link>
                                </div>
                              </form>
                            </div>
      
  );
}

export default LoginForm